import { GoogleSiteTag, GoogleAds } from "@/pixels/ofertaEmprendedores/google";

describe("GoogleSiteTag config", () => {
  beforeEach(() => {
    jest.spyOn(GoogleSiteTag, "enable");
    jest.spyOn(GoogleSiteTag, "wait");

    window.google_trackConversion = jest.fn();
  });

  GoogleSiteTag.enable();
  GoogleSiteTag.wait();

  const enableMock = jest.spyOn(GoogleSiteTag, "enable");
  const waitMock = jest.spyOn(GoogleSiteTag, "wait");

  expect(enableMock).toHaveBeenCalledTimes(0);
  expect(waitMock).toHaveBeenCalledTimes(0);

  it("configuracion exportada por defecto", () => {
    expect(GoogleSiteTag).toBeDefined();
    expect(GoogleSiteTag).not.toBeNull();
    expect(typeof GoogleSiteTag).toBe("object");
  });
});

describe("GoogleAds config", () => {
  beforeEach(() => {
    jest.spyOn(GoogleAds, "enable");
    jest.spyOn(GoogleAds, "wait");
    jest.spyOn(GoogleAds, "init");
    jest.spyOn(GoogleAds, "consulta");
    jest.spyOn(GoogleAds, "ofertaEmprendedores");

    document.createElement = jest.fn(() => ({
      addEventListener: jest.fn()
    }));
    document.getElementsByTagName = jest.fn(() => [
      {
        appendChild: jest.fn(),
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);
    window.gtag = jest.fn();
  });

  it("configuracion GoogleAds por defecto", () => {
    GoogleAds.enable();
    GoogleAds.wait();
    GoogleAds.init();
    GoogleAds.consulta();
    GoogleAds.ofertaEmprendedores();

    const enableMock = jest.spyOn(GoogleAds, "enable");
    const waitMock = jest.spyOn(GoogleAds, "wait");
    const initMock = jest.spyOn(GoogleAds, "init");
    const consultaMock = jest.spyOn(GoogleAds, "consulta");
    const ofertaEmprendedoresMock = jest.spyOn(
      GoogleAds,
      "ofertaEmprendedores"
    );

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(initMock).toHaveBeenCalledTimes(1);
    expect(consultaMock).toHaveBeenCalledTimes(1);
    expect(ofertaEmprendedoresMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion por defecto para enable", () => {
    window.dataLayer = undefined;
    window.gtag = undefined;
    const script = { onload: () => "", type: "" };
    document.createElement.mockReturnValue(script);
    GoogleSiteTag.enable();
    const enableMock = jest.spyOn(GoogleSiteTag, "enable");
    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(script.onload()).toEqual();

    expect(window.dataLayer).toBeDefined();
    expect(window.gtag).toBeDefined();

    window.gtag("event", "click", { event_category: "button" });
  });

  it("configuracion exportada por defecto", () => {
    expect(GoogleAds).toBeDefined();
    expect(GoogleAds).not.toBeNull();
    expect(typeof GoogleAds).toBe("object");
  });
});
